import back_icon from './back-icon.png';
import dark_arrow from './dark-arrow.png';
import about from './about.png';
import gallery_1 from './gallery-1.png';
import gallery_2 from './gallery-2.png';
import gallery_3 from './gallery-3.png';
import gallery_4 from './gallery-4.png';
import hero from './hero.png';
import location_icon from './location-icon.png';
import logo from './logo.png';
import mail_icon from './mail-icon.png';
import menu_icon from './menu-icon.png';
import msg_icon from './msg-icon.png';
import next_icon from './next-icon.png';
import phone_icon from './phone-icon.png';
import play_icon from './play-icon.png';
import program_1 from './program-1.png';
import program_2 from './program-2.png';
import program_3 from './program-3.png';
import program_icon_1 from './program-icon-1.png';
import program_icon_2 from './program-icon-2.png';
import program_icon_3 from './program-icon-3.png';
import user_1 from './user-1.png';
import user_2 from './user-2.png'
import user_3 from './user-3.png';
import user_4 from './user-4.png';
import white_arrow from './white-arrow.png';
import video from "./Screen Recording 2025-04-15 114953.mp4"


export const assets = {
back_icon,
dark_arrow,
about,
gallery_1,
gallery_2,
gallery_3,
gallery_4,
hero,
location_icon,
logo,
mail_icon,
menu_icon,
msg_icon,
next_icon,
phone_icon,
play_icon,
program_1,
program_2,
program_3,
program_icon_1,
program_icon_2,
program_icon_3,
user_1,
user_2,
user_3,
user_4,
white_arrow,
video
}
export default assets;